// import React, { useState } from "react";
// import {
//   Box,
//   CardContent,
//   Typography,
//   TextField,
//   Button,
//   Grid,
//   Divider,
//   Snackbar,
//   Alert,
//   CircularProgress,
// } from "@mui/material";
// import axiosInstance from "../../services/axiosInterceptors";
// import apiEndPointsConfig from "../../services/apiEndPoints";
// import { useFormik } from "formik";
// import * as Yup from "yup";

// export default function PasswordUpdate() {
//   const token = localStorage.getItem("token");
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [snackbarSeverity, setSnackbarSeverity] = useState("error");

//   const validationSchema = Yup.object({
//     currentPassword: Yup.string()
//       .required("Current password is required")
//       .matches(/^\S+$/, "Password cannot contain spaces"),
//     newPassword: Yup.string()
//       .required("New password is required")
//       .min(6, "Password must be at least 6 characters")
//       .matches(/^\S+$/, "Password cannot contain spaces"),
//     confirmPassword: Yup.string()
//       .required("Please confirm your password")
//       .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
//       .matches(/^\S+$/, "Password cannot contain spaces"),
//   });

//   const formik = useFormik({
//     initialValues: {
//       currentPassword: "",
//       newPassword: "",
//       confirmPassword: "",
//     },
//     validationSchema,
//     onSubmit: async (values) => {
//       const data = {
//         oldPassword: values.currentPassword,
//         newPassword: values.newPassword,
//         confirmPassword: values.confirmPassword,
//       };

//       try {
//         setLoading(true);
//         const res = await axiosInstance.put(
//           apiEndPointsConfig?.changePassword,
//           data,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );


//         setSnackbarSeverity("success");
//         setSnackbarMessage("Password changed successfully");
//         setSnackbarOpen(true);
//         formik.resetForm();
//       } catch (error) {
//         console.log(
//           "Error changing password:",
//           error?.response?.data?.status?.value
//         );

//         setSnackbarSeverity("error");
//         if (
//           error?.response?.status === 400 &&
//           error?.response?.data?.status?.value === "Old password is incorrect"
//         ) {
//           setSnackbarMessage("Old password given is incorrect");
//         } else if (
//           error?.response?.status === 400 &&
//           error?.response?.data?.status?.value ===
//             "New password must be different from the old password"
//         ) {
//           setSnackbarMessage(
//             "New password must be different from the old password"
//           );
//         } else {
//           setSnackbarMessage("Something went wrong, please try again");
//         }
//         setSnackbarOpen(true);
//       } finally {
//         setLoading(false);
//       }
//     },
//   });

//   return (
//     <Box sx={{ width: "100%", mt: 3 }}>
//       <Box
//         sx={{
//           borderRadius: 3,
//           width: "100%",
//           border: "1px solid #E0E0E0",
//         }}
//       >
//         <CardContent sx={{ p: 4 }}>
//           {/* Heading */}
//           <Box sx={{ mb: 4 }}>
//             <Typography
//               variant="h6"
//               sx={{
//                 fontWeight: 500,
//                 color: "#1E1E2F",
//               }}
//             >
//               Change your password
//             </Typography>
//           </Box>

//           <Divider sx={{ mb: 4, borderColor: "#E5E7EB" }} />

//           <form onSubmit={formik.handleSubmit}>
//             <Grid container spacing={2}>
//               {/* Current Password */}
//               <Grid item xs={12}>
//                 <Typography
//                   variant="body2"
//                   sx={{ mb: 1, fontWeight: 500, color: "#4F46E5" }}
//                 >
//                   Current Password
//                 </Typography>
//                 <TextField
//                   fullWidth
//                   type="password"
//                   name="currentPassword"
//                   value={formik.values.currentPassword}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   placeholder="Enter current password"
//                   variant="outlined"
//                   disabled={loading}
//                   error={
//                     formik.touched.currentPassword &&
//                     Boolean(formik.errors.currentPassword)
//                   }
//                   helperText={
//                     formik.touched.currentPassword &&
//                     formik.errors.currentPassword
//                   }
//                   sx={{
//                     backgroundColor: "white",
//                     "& .MuiOutlinedInput-root": {
//                       borderRadius: "10px",
//                       "&:hover fieldset": { borderColor: "#6366F1" },
//                       "&.Mui-focused fieldset": { borderColor: "#6366F1" },
//                     },
//                   }}
//                 />
//               </Grid>

//               {/* New Password */}
//               <Grid item xs={12}>
//                 <Typography
//                   variant="body2"
//                   sx={{ mb: 1, fontWeight: 500, color: "#4F46E5" }}
//                 >
//                   New Password
//                 </Typography>
//                 <TextField
//                   fullWidth
//                   type="password"
//                   name="newPassword"
//                   value={formik.values.newPassword}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   placeholder="Enter new password"
//                   variant="outlined"
//                   disabled={loading}
//                   error={
//                     formik.touched.newPassword &&
//                     Boolean(formik.errors.newPassword)
//                   }
//                   helperText={
//                     formik.touched.newPassword && formik.errors.newPassword
//                   }
//                   sx={{
//                     backgroundColor: "white",
//                     "& .MuiOutlinedInput-root": {
//                       borderRadius: "10px",
//                       "&:hover fieldset": { borderColor: "#6366F1" },
//                       "&.Mui-focused fieldset": { borderColor: "#6366F1" },
//                     },
//                   }}
//                 />
//               </Grid>

//               {/* Confirm Password */}
//               <Grid item xs={12}>
//                 <Typography
//                   variant="body2"
//                   sx={{ mb: 1, fontWeight: 500, color: "#4F46E5" }}
//                 >
//                   Confirm Password
//                 </Typography>
//                 <TextField
//                   fullWidth
//                   type="password"
//                   name="confirmPassword"
//                   value={formik.values.confirmPassword}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   placeholder="Confirm new password"
//                   variant="outlined"
//                   disabled={loading}
//                   error={
//                     formik.touched.confirmPassword &&
//                     Boolean(formik.errors.confirmPassword)
//                   }
//                   helperText={
//                     formik.touched.confirmPassword &&
//                     formik.errors.confirmPassword
//                   }
//                   sx={{
//                     backgroundColor: "white",
//                     "& .MuiOutlinedInput-root": {
//                       borderRadius: "10px",
//                       "&:hover fieldset": { borderColor: "#6366F1" },
//                       "&.Mui-focused fieldset": { borderColor: "#6366F1" },
//                     },
//                   }}
//                 />
//               </Grid>
//             </Grid>

//             {/* Save Button */}
//             <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
//               <Button
//                 variant="contained"
//                 type="submit"
//                 disabled={loading}
//                 sx={{
//                   bgcolor: "#6366F1",
//                   color: "white",
//                   px: 3,
//                   py: 1.2,
//                   borderRadius: "12px",
//                   fontWeight: 500,
//                   textTransform: "none",
//                   boxShadow: "0px 4px 12px rgba(99, 102, 241, 0.4)",
//                   "&:hover": {
//                     bgcolor: "#4F46E5",
//                     boxShadow: "0px 6px 14px rgba(99, 102, 241, 0.5)",
//                   },
//                 }}
//               >
//                 {loading ? (
//                   <CircularProgress size={24} color="inherit" />
//                 ) : (
//                   "Change Password"
//                 )}
//               </Button>
//             </Box>
//           </form>
//         </CardContent>
//       </Box>

//       {/* Snackbar */}
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={4000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//       >
//         <Alert
//           severity={snackbarSeverity}
//           sx={{ width: "100%" }}
//           onClose={() => setSnackbarOpen(false)}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }





import React, { useState } from "react";
import {
  Box,
  CardContent,
  Typography,
  TextField,
  Button,
  Grid,
  Divider,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import axiosInstance from "../../services/axiosInterceptors";
import apiEndPointsConfig from "../../services/apiEndPoints";
import { useFormik } from "formik";
import * as Yup from "yup";
import { palette, theme  as colorTheme} from "../../Convoze.theme";


const primary = colorTheme("palette", "primary").value;
const primaryBg = colorTheme("palette", "primaryBg").value;
const positive = colorTheme("palette", "positive").value;
const negative = colorTheme("palette", "negative").value;
const neutral = colorTheme("palette", "neutral").value;
const secondary = colorTheme('palette', 'secondary').value
const night = colorTheme('palette', 'night').value


export default function PasswordUpdate() {
  const token = localStorage.getItem("token");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");

  const validationSchema = Yup.object({
    currentPassword: Yup.string()
      .required("Current password is required")
      .matches(/^\S+$/, "Password cannot contain spaces"),
    newPassword: Yup.string()
      .required("New password is required")
      .min(6, "Password must be at least 6 characters")
      .matches(/^\S+$/, "Password cannot contain spaces"),
    confirmPassword: Yup.string()
      .required("Please confirm your password")
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
      .matches(/^\S+$/, "Password cannot contain spaces"),
  });

  const formik = useFormik({
    initialValues: {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const data = {
        oldPassword: values?.currentPassword,
        newPassword: values?.newPassword,
        confirmPassword: values?.confirmPassword,
      };

      try {
        setLoading(true);
        const res = await axiosInstance.put(
          apiEndPointsConfig?.changePassword,
          data,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setSnackbarSeverity("success");
        setSnackbarMessage("Password changed successfully");
        setSnackbarOpen(true);
        formik.resetForm();
      } catch (error) {
        console.log(
          "Error changing password:",
          error?.response?.data?.status?.value
        );

        setSnackbarSeverity("error");
        if (
          error?.response?.status === 400 &&
          error?.response?.data?.status?.value === "Old password is incorrect"
        ) {
          setSnackbarMessage("Old password given is incorrect");
        } else if (
          error?.response?.status === 400 &&
          error?.response?.data?.status?.value ===
            "New password must be different from the old password"
        ) {
          setSnackbarMessage(
            "New password must be different from the old password"
          );
        } else {
          setSnackbarMessage("Something went wrong, please try again");
        }
        setSnackbarOpen(true);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Box sx={{ width: "100%", }}>
      <Box
        sx={{
          borderRadius: 3,
          width: "100%",
          border: "1px solid #E0E0E0",
        }}
      >
        <CardContent sx={{ p: 4 }}>
          {/* Heading */}
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: "#1E1E2F",
                fontSize: "1.25rem",
              }}
            >
              Change Your Password
            </Typography>
            <Typography
              variant="body2"
              sx={{
                // color: "#6B7280",
                color : secondary,
                mt: 1,
              }}
            >
              Update your password to keep your account secure
            </Typography>
          </Box>

          <Divider sx={{ mb: 5, borderColor: "#E5E7EB" }} />

          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={4}>
              {/* Current Password */}
              <Grid item xs={12}>
                <Typography
                  variant="body1"
                  sx={{ 
                    mb: 2, 
                    fontWeight: 600, 
                    // color: "#374151",
                    color : secondary,
                    fontSize: "0.95rem"
                  }}
                >
                  Current Password 
                </Typography>
                <TextField
                  fullWidth
                  type="password"
                  name="currentPassword"
                  value={formik.values?.currentPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Enter your current password"
                  variant="outlined"
                  disabled={loading}
                  error={
                    formik.touched?.currentPassword &&
                    Boolean(formik.errors?.currentPassword)
                  }
                  helperText={
                    formik.touched?.currentPassword &&
                    formik.errors?.currentPassword
                  }
                  sx={{
                    backgroundColor: "white",
                    "& .MuiInputBase-input::placeholder": {
                      // color: "#9CA3AF",
                      color : secondary,
                      opacity: 1,
                    },
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      fontSize: "0.95rem",
                      "&:hover fieldset": {
                        //  borderColor: "#6366F1" 
                        borderColor : primary,
                        }
                         ,
                      "&.Mui-focused fieldset": { 
                        // borderColor: "#6366F1",
                        borderColor : primary,
                         borderWidth: "2px" },
                    },
                  }}
                />
              </Grid>

              {/* New Password */}
              <Grid item xs={12}>
                <Typography
                  variant="body1"
                  sx={{ 
                    mb: 2, 
                    fontWeight: 600, 
                    color: "#374151",
                    fontSize: "0.95rem"
                  }}
                >
                  New Password 
                </Typography>
                <TextField
                  fullWidth
                  type="password"
                  name="newPassword"
                  value={formik.values?.newPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Create a strong password "
                  variant="outlined"
                  disabled={loading}
                  error={
                    formik.touched?.newPassword &&
                    Boolean(formik.errors?.newPassword)
                  }
                  helperText={
                    formik.touched?.newPassword && formik.errors?.newPassword
                  }
                  sx={{
                    backgroundColor: "white",
                    "& .MuiInputBase-input::placeholder": {
                      color: "#9CA3AF",
                      opacity: 1,
                    },
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      fontSize: "0.95rem",
                      "&:hover fieldset": { 
                        // borderColor: "#6366F1"
                        borderColor : primary,
                       },
                      "&.Mui-focused fieldset": { 
                        // borderColor: "#6366F1",
                        borderColor :  primary,
                         borderWidth: "2px" },
                    },
                  }}
                />
              </Grid>

              {/* Confirm Password */}
              <Grid item xs={12}>
                <Typography
                  variant="body1"
                  sx={{ 
                    mb: 2, 
                    fontWeight: 600, 
                    // color: "#374151",
                    color : secondary,
                    fontSize: "0.95rem"
                  }}
                >
                  Confirm New Password 
                </Typography>
                <TextField
                  fullWidth
                  type="password"
                  name="confirmPassword"
                  value={formik.values?.confirmPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Re-enter your new password"
                  variant="outlined"
                  disabled={loading}
                  error={
                    formik.touched?.confirmPassword &&
                    Boolean(formik.errors?.confirmPassword)
                  }
                  helperText={
                    formik.touched?.confirmPassword &&
                    formik.errors?.confirmPassword
                  }
                  sx={{
                    backgroundColor: "white",
                    "& .MuiInputBase-input::placeholder": {
                      // color: "#9CA3AF",
                      color : secondary,
                      opacity: 1,
                    },
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      fontSize: "0.95rem",
                      "&:hover fieldset": {
                        //  borderColor: "#6366F1"
                        borderColor : primary,
                         },
                      "&.Mui-focused fieldset": { 
                        // borderColor: "#6366F1", 
                        borderColor : primary,
                        borderWidth: "2px" },
                    },
                  }}
                />
              </Grid>
            </Grid>

            {/* Save Button */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 5 }}>
              <Button
                variant="contained"
                type="submit"
                disabled={loading}
                sx={{
                  // bgcolor: "#6366F1",
                  bgcolor : primary,
                  color: "white",
                  px: 4,
                  py: 1.5,
                  borderRadius: "12px",
                  fontWeight: 600,
                  textTransform: "none",
                  fontSize: "0.95rem",
                  boxShadow: "0px 4px 12px rgba(99, 102, 241, 0.4)",
                  "&:hover": {
                    // bgcolor: "#4F46E5",
                    bgcolor : primary,
                    boxShadow: "0px 6px 14px rgba(99, 102, 241, 0.5)",
                    transform: "translateY(-1px)",
                  },
                  "&:disabled": {
                    // bgcolor: "#9CA3AF",
                    bgcolor : secondary,
                    boxShadow: "none",
                  },
                  transition: "all 0.2s ease",
                }}
              >
                {loading ? (
                  <>
                    <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
                    Updating...
                  </>
                ) : (
                  "Update Password"
                )}
              </Button>
            </Box>
          </form>
        </CardContent>
      </Box>

      {/* Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          onClose={() => setSnackbarOpen(false)}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}



